<template>
  <div>
    <iModal
      :title="modelTitle"
      v-model="showModal"
      class-name="vertical-center-modal"
      width="600px"
      :mask-closable="false"
      @on-cancel="cancel"
    >
      <div class="admin-add">
        <div class="admin-add-content">
          <Form
            ref="formInline"
            :model="formInline"
            :rules="ruleInline"
            label-position="right"
            :label-width="100"
            @submit.native.prevent
          >
            <FormItem label="姓名：" prop="name">
              <Input type="text" v-model="formInline.name" placeholder="请输入姓名" />
            </FormItem>
            <FormItem label="手机：" prop="mobile">
              <div class="phone-inp">
                <Input v-model="formInline.mobile" disabled></Input>
                <span class="phone-inp__txt" @click="visible2 = true">更改</span>
              </div>
            </FormItem>
            <FormItem label="邮箱：" prop="email">
              <Input type="email" v-model="formInline.email" placeholder="请输入邮箱" />
            </FormItem>
            <FormItem label="公司：" prop="company">
              <Input type="text" v-model="formInline.company" placeholder="请输入公司" />
            </FormItem>
            <FormItem label="职位：" prop="jobTitle">
              <Input type="text" v-model="formInline.jobTitle" placeholder="请输入职务" />
            </FormItem>
            <FormItem label="城市：" prop="city">
              <Cascader
                v-model="formInline.city"
                placeholder="请选择城市"
                change-on-select
                :load-data="loadData"
                :data="provinceArr"
              ></Cascader>
            </FormItem>
          </Form>
        </div>
      </div>
      <div slot="footer">
        <Button type="primary" :loading="loading" @click="handleSubmit('formInline')">保存</Button>
        <Button @click="cancel">取消</Button>
      </div>
    </iModal>

    <iModal
      v-model="visible2"
      title="更换手机号"
      :z-index="1012"
      @on-cancel="cancel2('formItem')"
      class-name="vertical-center-modal changeNum myModel"
    >
      <Form :label-width="80" :model="formItem" :rules="formRule" ref="formItem">
        <FormItem label="手机：" prop="Phone">
          <Input v-model="formItem.Phone" placeholder="请输入新手机号"></Input>
        </FormItem>
        <FormItem label="验证码：">
          <Input v-model="code" placeholder="短信验证码" style="width:282px;"></Input>
          <Button
            type="primary"
            ghost
            @click="SendCode()"
            :disabled="codeBool"
            style="width:120px;margin-left:6px;"
          >{{codeTip}}</Button>
        </FormItem>
      </Form>
      <div slot="footer">
        <Button type="primary" @click="bindNewPhone">保存</Button>
        <Button @click="cancel2('formItem')">取消</Button>
      </div>
    </iModal>
  </div>
</template>

<script>
import { provinces } from "@/other/provinces";
import { validator } from "@/other/validator";
import { mapGetters, mapActions } from "vuex";

export default {
  // 修改用户信息
  name: "edit-info",
  props: {
    show: {
      type: Boolean,
      default: false
    },
    modelTitle: {
      type: String
    },
    options: {
      type: Object
    }
  },
  data() {
    return {
      provinceArr: [],
      visible3: false,
      mobile: false,
      loading: false,
      showModal: false,
      showCode: true, // 是否可以获取验证码
      count: "", // 获取验证码的秒数
      formInline: {
        // form双向绑定
        name: "", // 姓名
        mobile: "", // 手机
        jobTitle: "", // 职务
        company: "", // 职务
        email: "",
        city: []
      },
      editId: "",
      ruleInline: {
        // 效验规则
        name: [
          {
            required: true,
            message: "用户为必填选项",
            trigger: "blur",
            type: "string"
          }
        ],
        jobTitle: [
          {
            required: true,
            message: "职务为必填选项",
            trigger: "blur"
          }
        ],
        mobile: validator.phone,
        email: validator.email,
        company: [
          {
            required: true,
            message: "公司为必填选项",
            trigger: "blur"
          }
        ]
      },

      // 修改手机号
      visible2: false,
      formItem: {
        Phone: ""
      },
      code: "",
      codeBool: false, // 验证码开关
      codeTimer: null, // 验证码定时器
      codeTip: "获取验证码", // 验证码文本提示
      formRule: {
        Phone: validator.phone
      }
    };
  },
  watch: {
    show(val, oldVal) {
      this.showModal = val;
      if (!val) this.$emit("close");
      if (val) {
        this.init();
      }
    }
  },
  computed: {
    ...mapGetters({
      user: "getUser",
      exhibiton: "loginModule/getExhibition"
    })
  },
  mounted() {
    this.provinceArr = provinces.data; // 城市数据
    this.init();
  },
  methods: {
    ...mapActions({
      validCode: "validCode",
      getUser: "loginModule/getUser",
      saveUser: "saveUser",
      getCode: "loginModule/getCode",
      bindPhoneApply: "loginModule/bindPhoneApply",
      validateMsgCode: "loginModule/validateMsgCode"
    }),
    init() {
      if (this.user) {
        this.formInline.name = this.user.name;
        this.formInline.jobTitle = this.user.jobTitle;
        this.formInline.mobile = this.user.phoneNumber;
        this.formInline.email = this.user.email;
        this.formInline.company = this.user.compName;
        this.formInline.city = [
          this.user.province,
          this.user.city,
          this.user.country
        ];
        this.editId = this.user.userId;
      }
    },
    async handleSubmit(name) {
      let form = this.formInline;
      let valid = await this.validForm(name);
      if (!valid) return;
      this.loading = true;
      this.editInfo(form);
    },
    validForm(name) {
      // 验证表单
      return new Promise((resolve, reject) => {
        this.$refs[name].validate(valid => {
          resolve(valid);
        });
      });
    },
    async editInfo(form) {
      // 编辑用户信息
      let req = {
        id: this.editId,
        Phone: form.mobile,
        setValues: {
          Name: form.name,
          JobTitle: form.jobTitle,
          CompName: form.company,
          PhoneNumber: form.mobile,
          Email: form.email,
          Province: form.city.length ? form.city[0] : "",
          City: form.city.length ? form.city[1] : "",
          Country: form.city.length ? form.city[2] : ""
        }
      };
      var result = await this.saveUser(req);
      if (result.successed) {
        this.loading = false;
        this.$Message.success("修改成功！");
        this.cancel();
        let user = await this.getUser();
        this.$emit("finsh");
      } else {
        this.loading = false;
        if (result.errors && result.errors[0]) {
          this.$Message.error(result.errors[0].description);
          return;
        } else {
          this.$Message.error("修改失败，请重新尝试");
        }
      }
    },
    cancel() {
      this.$refs["formInline"].resetFields();
      this.$emit("close");
    },
    cancel3() {
      this.$refs["formItem"].resetFields();
      this.visible2 = false;
      this.formItem = {
        Phone: ""
      };
      this.code = "";
      this.codeBool = false; // 验证码开关
      this.codeTimer = null; // 验证码定时器
      this.codeTip = "获取验证码"; // 验证码文本提示
    },

    loadData(item, callback) {
      item.loading = true;
      setTimeout(() => {
        console.log(item);
        item.loading = false;
        callback();
      }, 1000);
    },

    cancel2(name) {
      this.visible2 = false;
      this.$refs[name].resetFields();
      this.code = "";
      clearInterval(this.codeTimer);
      this.codeTip = "获取验证码";
      this.codeTimer = null;
      this.codeBool = false;
    },
    // 验证 表单是否为空
    async formCode(name) {
      return new Promise((resolve, reject) => {
        if (this.code.trim() === "") {
          this.$Message.warning("验证码不能为空");
          resolve(false);
          return;
        } else {
          resolve(true);
        }
      });
    },
    async SendCode() {
      let bool = await this.validForm("formItem");
      if (!bool) return;
      const valid = await this.getCode({
        UserId: this.user.userId,
        Phone: this.formItem.Phone
      });
      if (!valid) return;
      this.codeTxt();
    },

    codeTxt() {
      if (this.codeTimer) return;
      this.codeTimer = true;
      this.codeBool = true;
      let num = 60;
      this.codeTimer = setInterval(() => {
        if (num !== 0) {
          this.codeTip = --num + "s";
        } else {
          clearInterval(this.codeTimer);
          this.codeTip = "获取验证码";
          this.codeTimer = null;
          this.codeBool = false;
        }
      }, 1000);
    },
    async bindNewPhone() {
      let bool = await this.validForm("formItem");
      if (!bool) return;
      // 绑定新手机
      let valid = await this.bindPhoneApply({
        UserId: this.user.userId,
        NewPhoneNumber: this.formItem.Phone,
        OldPhoneNumber: this.user.phoneNumber,
        token: this.code
      }); 
      if (!valid) {
        this.$Message.error("验证未通过!");
        return false;
      }
      if (valid.errors && valid.errors[0]) {
        if (valid.errors[0].code === -1) {
          this.$Message.error("无效的验证码");
          return;
        }
        if (valid.errors[0].description) {
          this.$Message.error(valid.errors[0].description);
          return;
        }
        this.$Message.error("验证码错误！");
        return;
      }
      this.$Message.success("绑定成功!");
      this.cancel3();
      this.refreshUser();
    },
    async refreshUser() {
      let user = await this.getUser();
      this.init();
    }
  }
};
</script>

<style scoped lang="scss">
.admin-add {
  &-content {
    padding: 20px 40px 20px 20px;
  }
}
.admin-add {
  &-title {
    width: 100%;
    text-align: center;
    margin-bottom: 20px;
    font-size: 16px;
  }
  &-content {
    .submit {
      display: flex;
      justify-content: center;
      button {
        margin-left: -75px;
      }
    }
    img {
      width: 150px;
      height: 150px;
    }
  }
  .form-code-item {
    position: relative;
    .form-code-btn {
      position: absolute;
      right: 1px;
      width: 96px;
      top: 2px;
      border: none;
      outline: none;
      &:focus {
        box-shadow: none;
        border: none;
        outline: none;
      }
    }
  }
}
.phone-inp {
  position: relative;
  &__txt {
    position: absolute;
    top: 2px;
    right: 9px;
    line-height: 32px;
    cursor: pointer;
    color: red;
  }
}
</style>

